export const DAYS_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] as const;

export type DayOfWeek = (typeof DAYS_ORDER)[number];

export const sortDays = (days: DayOfWeek[]): DayOfWeek[] => {
  return [...days].sort((a, b) => DAYS_ORDER.indexOf(a) - DAYS_ORDER.indexOf(b));
};

export const daysToIndices = (days: DayOfWeek[]): number[] => days.map((day) => DAYS_ORDER.indexOf(day));
